import React from "react";
import { E500 } from "../Components";

export const InternalServerError = () => {
  return <E500 />;
};
